import "./index.css";
const CompanyComponent = ({ name, address_line_1, iconComponent }) => {
  return (
    <div className="companycomponentnew__container">
      <div className="companycomponentnew">
        <h5>{name}</h5>
        <h6>{address_line_1}</h6>
        <div className="companycomponentnew__icon">
          <img src={iconComponent} alt="Company Component Icon" />
        </div>
      </div>
      <div className="companycomponentnew__option"></div>
    </div>
  );
};

export default CompanyComponent;
